'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dApp$002dRouter$0024$002dEdit$002dRecipe$002dApp$002dPage from "./mealorama.-App-Router$-Edit-Recipe-App-Page.js";
var $p;
/** @constructor */
function $c_Lmealorama_AppRouter$EditRecipeAppPage$() {
}
export { $c_Lmealorama_AppRouter$EditRecipeAppPage$ as $c_Lmealorama_AppRouter$EditRecipeAppPage$ };
$p = $c_Lmealorama_AppRouter$EditRecipeAppPage$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_AppRouter$EditRecipeAppPage$;
/** @constructor */
function $h_Lmealorama_AppRouter$EditRecipeAppPage$() {
}
export { $h_Lmealorama_AppRouter$EditRecipeAppPage$ as $h_Lmealorama_AppRouter$EditRecipeAppPage$ };
$h_Lmealorama_AppRouter$EditRecipeAppPage$.prototype = $p;
$p.m = (function() {
  return "EditRecipeAppPage";
});
$p.aS3 = (function(x$0) {
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x$0.g(0));
  return new $j_mealorama$002e$002dApp$002dRouter$0024$002dEdit$002dRecipe$002dApp$002dPage.$c_Lmealorama_AppRouter$EditRecipeAppPage($x_1.l, $x_1.h);
});
var $d_Lmealorama_AppRouter$EditRecipeAppPage$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_AppRouter$EditRecipeAppPage$, "mealorama.AppRouter$EditRecipeAppPage$", ({
  Fp: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_AppRouter$EditRecipeAppPage$ as $d_Lmealorama_AppRouter$EditRecipeAppPage$ };
var $n_Lmealorama_AppRouter$EditRecipeAppPage$;
function $m_Lmealorama_AppRouter$EditRecipeAppPage$() {
  if ((!$n_Lmealorama_AppRouter$EditRecipeAppPage$)) {
    $n_Lmealorama_AppRouter$EditRecipeAppPage$ = new $c_Lmealorama_AppRouter$EditRecipeAppPage$();
  }
  return $n_Lmealorama_AppRouter$EditRecipeAppPage$;
}
export { $m_Lmealorama_AppRouter$EditRecipeAppPage$ as $m_Lmealorama_AppRouter$EditRecipeAppPage$ };
//# sourceMappingURL=mealorama.-App-Router$-Edit-Recipe-App-Page$.js.map
